import moment from 'moment'
import { distinctUntilChanged, filter, ignoreElements, tap } from 'rxjs/operators'
import { ofType } from 'redux-observable'
import { track } from 'tracking/mixPanel'
import * as Actions from 'store/actions/index.ts'
import {
  getBenefitsConf,
  getHasPackages,
  getHasVisibleDepartureDatePicker,
  getOperationCode,
  getProductSourceKey,
  getProductTitle,
  getSelectedBenefits,
  getSelectedCheckin,
  getSelectedParticipants
} from 'store/selectors'
import { STATUS } from 'constants/checkout'
import { getFormatParticipants } from 'domain/pricerParticipants'
import { disableMixPanelTracking } from '../disable'

const mapStateToMPEvent = (eventName, state) => {
  const MPEvent = {
    'Error Name': 'Unavailable Order Pipe',
    'Event Name': eventName,
    'Operation Code': getOperationCode(state),
    'Page Name': 'Product Page',
    'Product': getProductTitle(state),
    'Product ID': getProductSourceKey(state)
  }

  if (getHasPackages(state)) {
    const hasVisibleDepartureDatePicker = getHasVisibleDepartureDatePicker(state)
    const selectedCheckin = getSelectedCheckin(state)
    const selectedParticipants = getSelectedParticipants(state)
    const benefitsConf = getBenefitsConf(state)
    const selectedBenefits = getSelectedBenefits(state)

    if (hasVisibleDepartureDatePicker) {
      MPEvent['Search Date'] = moment(selectedCheckin).format('YYYY-MM-DDTHH:mm:ss')
    }
    if (selectedParticipants) {
      MPEvent['Family Config'] = getFormatParticipants(selectedParticipants)
    }
    if (selectedBenefits) {
      MPEvent['Offer Type Category'] = benefitsConf?.labels.singular
      MPEvent['Number Of Offer Type Selected'] = selectedBenefits
    }
  }

  return MPEvent
}

const checkoutTechnicalErrorEpic = (actions$, state$) => actions$.pipe(
  disableMixPanelTracking(actions$),
  ofType(Actions.checkout.CHECKOUT_STATUS_CHANGED),
  distinctUntilChanged(),
  filter(({ payload }) => payload.status === STATUS.ERROR),
  tap((action) => {
    const eventName = 'Technical Error'

    track(eventName, mapStateToMPEvent(eventName, state$.value), { debug: !__PRODUCTION__ })
  }),
  ignoreElements()
)

export default checkoutTechnicalErrorEpic
